<template>
  <!-- eslint-disable vue/attribute-hyphenation -->
  <!-- eslint-disable vue/no-template-shadow -->
  <div class="page--category page--brand-detail">
    <div class="container">
      <GTopAds />
      <div class="row head hidden-xs hidden-sm">
        <div class="col-md-12 col-universal">
          <h2 class="sort-product__category-name">{{ brand.data.country }}</h2>
        </div>
      </div>
      <div class="row row--normalize">
        <div class="col col-left">
          <div class="sort-product">
            <div class="filter-group filter-group--by-category">
              <div v-if="isFinishLoadingListCategory">
                <ul v-if="categoriesList.length" class="brand-category">
                  <li>
                    <a @click="setSelectedCategory(null, 1)">All Products</a>
                  </li>
                  <li v-for="(category, i) in categoriesList" :key="`parent-${i}`">
                    <a
                      :class="{
                        'have-child': category.children && category.children.length,
                        selected: selectedCategories.parent === category._id,
                      }"
                      @click="setSelectedCategory(category._id, 1)"
                      >{{ category.name }}</a
                    >
                    <ul
                      v-if="category.children && category.children.length"
                      :class="['brand-category-nested', { active: selectedCategories.parent === category._id }]"
                    >
                      <li v-for="(category_child, idx) in category.children" :key="idx">
                        <a
                          :class="[
                            {
                              'have-child': category_child.children && category_child.children.length,
                              selected: selectedCategories.child === category_child._id,
                            },
                            'child',
                          ]"
                          @click="setSelectedCategory(category_child._id, 2)"
                          >{{ category_child.name }}</a
                        >
                        <ul
                          v-if="category_child.children && category_child.children.length"
                          :class="[
                            'brand-category-nested',
                            {
                              active: selectedCategories.child === category_child._id,
                            },
                          ]"
                        >
                          <li v-for="(category_grand_child, idxChild) in category_child.children" :key="idxChild">
                            <a
                              :class="[
                                'grand-child',
                                {
                                  selected: selectedCategories.grandchild === category_grand_child._id,
                                },
                              ]"
                              @click="setSelectedCategory(category_grand_child._id, 3)"
                              >{{ category_grand_child.name }}</a
                            >
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
                <ul v-else class="brand-category">
                  <li>
                    <a>All products</a>
                  </li>
                </ul>
              </div>
              <div v-else>
                <GFMP
                  v-for="i in 4"
                  :key="i"
                  :styles="{
                    minHeight: '26px',
                    width: '100%',
                    marginBottom: '10px',
                  }"
                />
              </div>
            </div>

            <div class="sort-product">
              <!-- filter availibility -->
              <div class="filter-group filter-group--by-brand">
                <h4 class="filter-group__heading">Availibility</h4>
                <ul class="list">
                  <li v-for="(avail, idx) in availibility" :key="idx" class="list__item">
                    <input
                      :id="avail"
                      v-model="filterAvailChecked"
                      type="checkbox"
                      name="filter_brand_desktop"
                      :value="avail"
                      class="checkbox"
                    />
                    <label>{{ `Available at ${avail == 'sociolla' ? 'Sociolla' : 'Lilla'}` }}</label>
                  </li>
                </ul>
              </div>

              <div class="filter-group filter-group--by-brand">
                <h4 class="filter-group__heading">Brands</h4>
                <div class="input-search-header">
                  <input
                    v-model="searchText"
                    type="text"
                    placeholder="Search..."
                    name="search_text_desktop"
                    class="form-control"
                    @keyup="searchingOnFilterBrand(searchText)"
                  />
                </div>
                <div>
                  <ul class="list-inline">
                    <li v-for="brandList in selectedBrandList" :key="brandList['_id']">
                      <div class="pill">
                        {{ brandList.name.toUpperCase() }}
                        <span class="pill-dismiss" @click.self.prevent="removeSelectedBrand(brandList['_id'])"></span>
                      </div>
                    </li>
                  </ul>
                </div>
                <ul v-if="isLoadingFinishSearchFilterBrand" class="list">
                  <li v-for="(brand, key) in brands" :key="brand['_id']" class="list__item">
                    <input
                      :id="`brandFilter${key}`"
                      v-model="filterBrandChecked"
                      type="checkbox"
                      name="filter_brand_desktop"
                      :value="`${brand['_id']}`"
                      class="checkbox"
                    />
                    <label v-if="brand.name" :for="`brandFilter${key}`">{{ brand.name.toUpperCase() }}</label>
                  </li>
                  <li v-if="!brands.length">No Results Found</li>
                </ul>
                <div v-else>
                  <GFMP v-for="i in 4" :key="i" :styles="{ marginBottom: '10px', minheight: '17px' }" />
                </div>
              </div>

              <!-- filter availibility -->
              <div class="filter-group filter-group--by-rating">
                <h4 class="filter-group__heading">Ratings</h4>
                <ul class="list">
                  <li class="list__item">
                    <label class="radio-donut">
                      <input v-model="filterRating" type="radio" name="rating_desktop" value="5" />
                      <GRatingInline averageRating="5.0" starFillNumber="50" />
                      <span></span>
                    </label>
                  </li>
                  <li class="list__item">
                    <label class="radio-donut">
                      <input v-model="filterRating" type="radio" name="rating_desktop" value="4" />
                      <GRatingInline averageRating="4.0" starFillNumber="40" />
                      <span></span>
                    </label>
                  </li>
                  <li class="list__item">
                    <label class="radio-donut">
                      <input v-model="filterRating" type="radio" name="rating_desktop" value="3" />
                      <GRatingInline averageRating="3.0" starFillNumber="30" />
                      <span></span>
                    </label>
                  </li>
                  <li class="list__item">
                    <label class="radio-donut">
                      <input v-model="filterRating" type="radio" name="rating_desktop" value="2" />
                      <GRatingInline averageRating="2.0" starFillNumber="20" />
                      <span></span>
                    </label>
                  </li>
                  <li class="list__item">
                    <label class="radio-donut">
                      <input v-model="filterRating" type="radio" name="rating_desktop" value="1" />
                      <GRatingInline averageRating="1.0" starFillNumber="10" />
                      <span></span>
                    </label>
                  </li>
                  <li class="list__item">
                    <label class="radio-donut">
                      <input v-model="filterRating" type="radio" name="rating_desktop" value="0" />
                      <GRatingInline averageRating="0.0" starFillNumber="0" />
                      <span></span>
                    </label>
                  </li>
                </ul>
              </div>

              <div class="group-btn">
                <button type="button" class="btn btn_white mr-15" @click.prevent="resetFilter">Reset</button>
                <button type="button" class="btn btn--black" @click.prevent="applyFilters">Apply</button>
              </div>
            </div>
          </div>
        </div>

        <div class="col col-center">
          <div class="section section--brand hidden-xs hidden-sm">
            <div v-if="brands.length">
              <div class="section__head">
                <h4 class="section__heading__origin">
                  Brand From {{ (brand.data.country || '').toUpperCase() }}
                  <a @click.prevent="showModalBrands()"> Lihat semua </a>
                </h4>
              </div>

              <div class="section__body">
                <ul class="list-brand-origin">
                  <li v-for="(brand, key) in brands" :key="key">
                    <router-link :to="`/brand/${brand.my_soco_sql_id}/${$options.filters.slug(brand.name)}`">
                      <img
                        v-if="brand.logo"
                        :src="brand.logo"
                        class="list-brand__img"
                        onerror="this.src='/assets/img/default_img_brand.svg'"
                        alt="SOCO"
                      />
                      <img v-else src="/assets/img/default_img_brand.svg" class="list-brand__img" alt="SOCO" />
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-else>
              <div class="section__head empty-result">
                <h4 class="section__heading">Brand</h4>

                <h6 class="section__total-found">No brand found.</h6>
              </div>
            </div>
          </div>
          <div class="gallery-product">
            <div class="gallery-product__toolbar">
              <ListSortProduct
                v-if="categoriesList.length"
                :listLeftMobile="categoriesList"
                :defaultSort="'popular'"
                :productCount="products.total"
                @filtered="filtered"
              >
              </ListSortProduct>
            </div>

            <div v-if="!products.loading" class="gallery-product__body">
              <div v-if="products && !products.loading && products.total > 0" class="row__product">
                <!-- totalProduct -->
                <div
                  v-for="(product, key) in products.data"
                  :key="key"
                  class="col-lg-4 col-md-6 col-xs-6 column-mobile"
                >
                  <GProduct :key="key" :inlineReviewers="true" :buttonReview="true" :product="product" />
                </div>
              </div>
              <div v-else class="gallery-product__empty">
                <img
                  v-if="screen.isDesktop"
                  src="/assets/img/icons/product-not-found.svg"
                  name="product-not-found"
                  alt=""
                  width="151"
                  height="151"
                />
                <img
                  v-else
                  src="/assets/img/icons/product-not-found.svg"
                  name="product-not-found"
                  alt=""
                  width="80"
                  height="80"
                />
                <p class="text">Maaf, tidak ada produk yang ditemukan</p>
                <button type="button" class="btn btn--black" @click.prevent="resetFilter">Reset filter</button>
              </div>
            </div>

            <div v-else>
              <div class="row">
                <div v-for="i in 12" :key="i" class="col-lg-4 col-md-6 col-xs-6 column-mobile">
                  <GFMP :styles="{ minHeight: '258px', marginBottom: '16px' }" />
                </div>
              </div>
            </div>
          </div>

          <Pagination
            v-if="products.total"
            key="Pagination"
            ref="paginationProduct"
            :limit="limitForProduct"
            :skip="skipForProduct"
            :totalItem="products.total"
            @skipTo="onChangePagination"
          />
        </div>
        <div ref="product-brand" class="mobile-head">
          <div class="section section--brand hidden-lg hidden-md">
            <div v-if="brands.length">
              <div class="section__head">
                <h4 class="section__heading__origin">
                  Brand From {{ (brand.data.country || '').toUpperCase() }}
                  <a @click.prevent="showModalBrands()"> Lihat semua </a>
                </h4>
              </div>

              <div class="section__body">
                <ul class="list-brand-origin">
                  <li v-for="(brand, key) in brands" :key="key">
                    <router-link :to="`/brand/${brand.my_soco_sql_id}/${$options.filters.slug(brand.name)}`">
                      <img
                        v-if="brand.logo"
                        :src="brand.logo"
                        class="list-brand__img"
                        onerror="this.src='/assets/img/default_img_brand.svg'"
                        alt="SOCO"
                      />
                      <img v-else src="/assets/img/default_img_brand.svg" class="list-brand__img" alt="SOCO" />
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-else>
              <div class="section__head empty-result">
                <h4 class="section__heading">Brand</h4>

                <h6 class="section__total-found">No brand found.</h6>
              </div>
            </div>
          </div>
          <ul class="mobile-categories">
            <li
              class="categories"
              :class="{
                active: Boolean(valueForQueryString.category_id) === false,
              }"
              @click.prevent="onChangeCategory(null)"
            >
              All Item
            </li>
            <li
              v-for="(category, idx) in categoriesList"
              :key="idx"
              class="categories"
              :class="{
                active: valueForQueryString.category_id === category._id,
              }"
              @click.prevent="onChangeCategory(category._id)"
            >
              <span v-if="category.total_products !== 0" class="list__total">{{ category.name | ucwords }}</span>
            </li>
          </ul>
        </div>

        <div class="col col-right">
          <div class="sidebar">
            <div v-if="brand.loading && !brand.data" class="popular-review">
              <GFMP :styles="{ minHeight: '123px', marginBottom: '5px' }" />
              <GFMP :styles="{ minHeight: '330px', marginBottom: '16px' }" />
            </div>

            <AddThoughts
              button-text="Write Review"
              button-redirect-url="/review/add"
              class="hidden-xs hidden-sm"
              copywriting="Ingin berkontribusi menambah review dengan konten yang menarik?"
            />
          </div>
        </div>
      </div>
    </div>

    <ModalBrands v-if="showModalOriginBrands" :origin="brand.data.country" :allBrands="brands" />

    <div v-if="!screen.isDesktop">
      <!-- <FilterBySortMobile
        :sortingTextActive="toggleTextSortDate"
        @onChange="onChangeSortDate"
        key="FilterBySortingMobile"
      />

      <FilterByRatingMobile
        @onChange="onChangeFilterRating"
        :filterRatingChecked="filterRatingChecked"
        key="FilterByRatingMobile"
      />

      <StickyFilterMobile key="Search-StickyFilterMobile" /> -->
      <ModalFilterSearch
        v-if="showModalFilterSearch"
        :brand_detail="brand"
        :list_brands="brands"
        :options="{ available: true, brands: true, rating: true }"
      />

      <div
        v-if="!screen.isDesktop"
        class="filter-product"
        :class="{
          'filter-product--active': 0,
          'filter-product--disabled': 0,
        }"
        @click.prevent="showModal"
      >
        <img
          v-if="isFiltered"
          src="/assets/img/icon-filter-revamp-active.svg"
          width="15"
          height="11"
          class="filter-product__img"
          alt="Filter icon"
        />
        <img
          v-else
          src="/assets/img/icon-filter-revamp.svg"
          class="filter-product__img"
          width="17"
          height="18"
          alt="Filter icon"
        />
        <span class="filter-product__text">Filter{{ Object.keys($route.query).length ? '' : '' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable one-var */
/* eslint-disable no-var */
const Config = require('~/config/default.env').default;
import Pagination from '@/components/global/pagination/pagination';
import AddThoughts from '@/components/global/add-thoughts/add-thoughts';
export default {
  name: 'brand-details',
  components: {
    AddThoughts,

    Pagination,
    ModalFilterSearch: () => import('@/components/global/modal/modal-filter-search'),
    ModalBrands: () => import('@/components/global/modal/modal-brands'),
    ListSortProduct: () => import('@/components/global/list-sort-product/list-sort-product'),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('setListProducts', []);
    next();
  },
  data() {
    return {
      brands: '',
      countrybrands: '',
      filterBrandChecked: [],
      searchBrandFilter: '',
      searchText: '',
      isLoadingFinishSearchFilterBrand: false,
      createdHookInit: false,
      valueForQueryString: {
        category_id: '',
        filter_rating: '',
        page: '',
        available_for: '',
        sort: '',
      },
      brand: {
        loading: true,
        data: {},
      },
      products: {
        loading: true,
        data: false,
        total: 0,
      },
      categoriesList: [],
      isFinishLoadingListCategory: false,
      limitForProduct: 12,
      skipForProduct: 0,
      toggleTextSortDate: 'popular',
      filterRatingChecked: '',
      paramsOfSort: '-review_stats.total_reviews',
      seeMoreOpen: false,
      selectedCategories: {
        parent: '',
        child: '',
        grandchild: '',
      },
      isScroll: false,
      scrollTop: 0,
      dropdownToggleText: '',
      filterCreated: 'newest',
      filterRatingss: 'rating',
      filterAvailChecked: [],
      availibility: ['sociolla', 'lulla'],
      filterRating: '',
      offsetProduct: 0,
    };
  },
  computed: {
    selectedBrandList() {
      const selectedBrandList = [];
      this.brands.length &&
        this.brands.forEach((brand) => {
          if (this.filterBrandChecked.includes(brand['_id'])) {
            selectedBrandList.push(brand);
          }
        });
      return selectedBrandList;
    },
    brandId() {
      return this.$route.params.brand_id;
    },
    brandDesc() {
      return this.brand.data.description
        ? this.$options.filters.stripHTML(this.brand.data.description)
        : this.$options.filters.stripHTML(this.brand.data.short_description);
    },
    queryStringOfCategoryId() {
      return this.$route.query.category_id;
    },
    queryStringOfPageValue() {
      return this.$route.query.page;
    },
    queryStringOfRatingValue() {
      return this.$route.query.filter_rating;
    },
    queryStringOfSortDateValue() {
      if (this.$route.query.sort) {
        return this.$route.query.sort;
      } else {
        return 'popular';
      }
    },
    screen() {
      return this.$store.state.screen;
    },
    copywritingFilterRating() {
      if (this.filterRatingss === 'rating') {
        return 'Rating: Tinggi - Rendah';
      } else {
        return 'Rating: Rendah - Tinggi';
      }
    },
    copywritingFilterCreated() {
      if (this.filterCreated === 'newest') {
        return 'Produk: Terbaru - Terlama';
      } else {
        return 'Produk: Terlama - Terbaru';
      }
    },
    showModalFilterSearch() {
      return this.$store.state.modal.isModalShow.filterSearch;
    },
    showModalOriginBrands() {
      return this.$store.state.modal.isModalShow.brands;
    },
    isFiltered() {
      const query = this.$route.query;
      if (Object.keys(query).length) {
        if (query.available_for || query.filter_rating || query.brand_id) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  watch: {
    brandId() {
      this.getCategories();
      // this.getProducts();
      this.getProductsTotal();
      this.getBrand();
      this.getAllBrand();
    },
    $route(to, from) {
      var isQueryStringSortHasChanged = to.query.sort !== from.query.sort,
        isQueryStringPageHasChanged = to.query.page !== from.query.page,
        isQueryStringRatingHasChanged = to.query.filter_rating !== from.query.filter_rating,
        isQueryStringCategoryIdHasChanged = to.query.category_id !== from.query.category_id,
        isQueryStringAvailableHasChanged = to.query.available_for !== from.query.available_for,
        isQueryStringBrandHasChanged = to.query.brand_id !== from.query.brand_id;
      //   to.params.brand_id !== from.params.brand_id;

      if (
        isQueryStringRatingHasChanged ||
        isQueryStringCategoryIdHasChanged ||
        isQueryStringAvailableHasChanged ||
        isQueryStringBrandHasChanged
      ) {
        this.resetPaginationState();
        // this.getProducts();
        this.getProductsTotal();
      } else if (isQueryStringSortHasChanged || isQueryStringPageHasChanged) {
        // this.getProducts();
        this.getProductsTotal();
      }

      this.$nextTick(() => {
        if (
          to.query.page ||
          to.query.category_id ||
          to.query.sort ||
          to.query.available_for ||
          to.query.filter_rating
        ) {
          if (this.offsetProduct > 0) {
            window.scrollTo(0, this.offsetProduct + 50);
          }
        }
      });
    },
    dropdownToggleText() {
      var sorting = this.dropdownToggleText.toLowerCase();
      if (sorting) {
        this.$route.query.sort = sorting;
      } else {
        this.$route.query.sort = '';
      }
    },
  },
  created() {
    this.createdHookInit = true;
    this.setDefaultFilter();
    this.setParams();
    // this.getProducts();
    this.getProductsTotal();
    this.getBrand();
    this.getAllBrand();

    if (this.$route.query.available_for) {
      this.filterAvailChecked = JSON.parse(this.$route.query.available_for);
    }

    if (this.$route.query.filter_rating) {
      this.filterRating = this.$route.query.filter_rating;
    }

    if (this.$route.query.brands) {
      this.filterAvailChecked = JSON.parse(this.$route.query.brands);
    }
  },
  mounted() {
    this.$nextTick(() => {
      const container = document.getElementsByClassName('mobile-head');
      if (container && container.length) {
        const { top } = container[0].getBoundingClientRect();
        this.offsetProduct = top;
      }
    });
  },
  methods: {
    // stickySortBy(e) {
    //   if(!this.screen.isDesktop){
    //       try {
    //           let sortby = document.getElementById("sticky_sortby_wrapper")
    //           let header = document.getElementById("stickyHeader")
    //           if (sortby) {
    //               let sticky = sortby.offsetTop - 10
    //               if ( window.scrollY > sticky ) {
    //                   this.isScroll = true
    //                   this.scrollTop = header.offsetHeight
    //               } else {
    //                   this.isScroll = false
    //                   this.scrollTop = 0
    //               }
    //           }
    //       }
    //       catch (e) {console.log(e)}
    //   }
    // },
    filtered(filtered) {
      let query = Object.assign({}, this.$route.query);
      const params = { ...filtered };

      delete query.sort;
      delete query.category_id;

      if (params.sort) {
        query = Object.assign(query, { sort: params.sort });
        this.toggleTextSortDate = params.sort;
        this.applyParamsOfSortValue();
      } else {
        (this.toggleTextSortDate = 'popular'), (this.paramsOfSort = '-review_stats.total_reviews');
      }

      if (params.filter.category && Object.keys(params.filter.category).length && params.filter.category._id) {
        query = Object.assign(query, {
          category_id: params.filter.category._id,
        });
      }

      this.valueForQueryString.category_id = query.category_id || '';

      this.$router.push(
        `/brand/${this.brandId}-${this.$options.filters.slug(
          this.brand.data.country
        )}?${this.$options.filters.serializeQS({
          ...query,
          page: 1,
        })}`
      );
    },
    searchingOnFilterBrand(value) {
      this.searchBrandFilter = value;
      this.getAllBrand();
    },
    removeSelectedBrand(key) {
      this.filterBrandChecked.splice(key, 1);
    },
    toggleSortProductByRating(sortRating) {
      this.filterRatingss =
        this.queryStringOfSortDateValue === 'rating'
          ? '-rating'
          : this.queryStringOfSortDateValue === '-rating'
          ? 'rating'
          : this.filterRatingss;
      this.onChangeSortDate(this.filterRatingss);
    },
    toggleSortProductByCreated(sortCreated) {
      this.filterCreated =
        this.queryStringOfSortDateValue === 'newest'
          ? 'oldest'
          : this.queryStringOfSortDateValue === 'oldest'
          ? 'newest'
          : this.filterCreated;
      this.onChangeSortDate(this.filterCreated);
    },
    toggleSeeMore() {
      this.seeMoreOpen = !this.seeMoreOpen;
    },
    showModal() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'filterSearch',
      });
    },
    showModalBrands() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'brands' });
    },
    applyFilters() {
      if (this.filterAvailChecked && this.filterAvailChecked.length) {
        this.valueForQueryString.available_for = this.filterAvailChecked;
        if (!this.createdHookInit) {
          this.resetPaginationState();
        }
        this.createdHookInit = false;
        this.applyRouteChange();
      }

      if (this.filterRating) {
        this.filterRatingChecked = '';
        this.valueForQueryString.filter_rating = this.filterRating;
        if (!this.createdHookInit) {
          this.resetPaginationState();
        }
        this.createdHookInit = false;
        this.applyRouteChange();
      }

      if (this.filterBrandChecked && this.filterBrandChecked.length) {
        this.valueForQueryString.brand_id = this.filterBrandChecked;
        if (!this.createdHookInit) {
          this.resetPaginationState();
        }
        this.createdHookInit = false;
        this.applyRouteChange();
      }
    },
    applyParamsOfSortValue() {
      const sortDateTextLowerCase = this.toggleTextSortDate.toLowerCase();
      if (sortDateTextLowerCase === 'popular') {
        this.paramsOfSort = '-review_stats.total_reviews';
      } else if (sortDateTextLowerCase === 'newest') {
        this.paramsOfSort = '-created_at';
      } else if (sortDateTextLowerCase === 'oldest') {
        this.paramsOfSort = 'created_at';
      } else if (sortDateTextLowerCase === 'rating') {
        this.paramsOfSort = '-review_stats.average_rating';
      } else if (sortDateTextLowerCase === '-rating') {
        this.paramsOfSort = 'review_stats.average_rating';
      } else {
        this.paramsOfSort = '-review_stats.total_reviews';
      }
    },
    applyRouteChange() {
      var queryString = this.buildQueryString(),
        changedPathValue = `/brand/${this.brandId}-${this.$options.filters.slug(
          this.brand.data.country
        )}?${this.buildQueryString()}`;

      if (queryString && this.$route.fullPath !== changedPathValue) {
        this.$router.push(changedPathValue);
      }

      if (!queryString) {
        this.$router.push(`/brand/${this.brandId}-${this.$options.filters.slug(this.brand.data.country)}`);
      }
    },
    buildQueryString() {
      const objectForQueryString = {};

      if (this.filterRating && this.screen.isDesktop) {
        objectForQueryString.filter_rating = this.filterRating;
      } else if (this.$route.query.filter_rating && !this.screen.isDesktop) {
        this.valueForQueryString.filter_rating = this.$route.query.filter_rating;
        objectForQueryString.filter_rating = this.valueForQueryString.filter_rating;
      }

      if (this.filterBrandChecked && this.filterBrandChecked.length && this.screen.isDesktop) {
        objectForQueryString.brand_id = this.filterBrandChecked;
      } else if (this.$route.query.filter_rating && !this.screen.isDesktop) {
        this.valueForQueryString.brand_id = this.$route.query.brand_id;
        objectForQueryString.brand_id = this.valueForQueryString.brand_id;
      }

      if (this.valueForQueryString.page) {
        objectForQueryString.page = this.valueForQueryString.page;
      }

      if (this.valueForQueryString.sort) {
        objectForQueryString.sort = this.valueForQueryString.sort.toLowerCase();
      }

      if (this.valueForQueryString.category_id) {
        objectForQueryString.category_id = this.valueForQueryString.category_id;
      }

      if (this.filterAvailChecked && this.filterAvailChecked.length && this.screen.isDesktop) {
        objectForQueryString.available_for = this.filterAvailChecked;
      } else if (this.$route.query.available_for && !this.screen.isDesktop) {
        this.valueForQueryString.available_for = this.$route.query.available_for;
        objectForQueryString.available_for = this.valueForQueryString.available_for;
      }
      return this.$options.filters.serializeQS(objectForQueryString);
    },
    getCategories() {
      this.isFinishLoadingListCategory = false;
      this.$MS_CATALOG_API_URL
        .get('v3/categories/distinct/products', {
          params: {
            filter: {
              'brand.country_tag_id': this.brandId,
              is_children: true,
            },
          },
        })
        .then((res) => {
          if (res.data.success && res.data.data.length > 0) {
            this.categoriesList = res.data.data.filter((c) => !!c);
          } else {
            this.categoriesList = [];
          }
          this.isFinishLoadingListCategory = true;
        })
        .catch((err) => {
          console.error(err);
          this.isFinishLoadingListCategory = true;
          this.categoriesList = [];
        });
    },
    getBrand() {
      this.$MS_SOCO_PUBLIC_API_URL
        .get(
          `/brands?filter=${JSON.stringify({
            country_tag_id: this.brandId,
          })}&limit=1`
        )
        .then((res) => {
          if (res.data.success && res.data.data.length > 0) {
            this.brand.data = res.data.data[0];
            this.brand.loading = false;
            this.$store.commit('setHeaderMeta', this.brand.data);
            this.getCategories();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllBrand() {
      const params = {
        limit: 20,
        filter: {
          'brand.country_tag_id': parseInt(this.$route.params.brand_id),
        },
      };
      const endpoint = `${Config.MS_CATALOG_API_URL}/v3/brands/distinct/products`;

      if (this.searchBrandFilter) {
        params.filter = {
          'brand.country_tag_id': parseInt(this.$route.params.brand_id),
          name: {
            $regex: '^' + String(this.searchBrandFilter).toLowerCase(),
            $options: 'i',
          },
        };
      } else if (this.query) {
        params.filter = {
          'brand.country_tag_id': parseInt(this.$route.params.brand_id),
          $or: [
            {
              'brand.name': {
                $regex: String(this.query).toLowerCase(),
                $options: 'i',
              },
            },
            {
              name: { $regex: String(this.query).toLowerCase(), $options: 'i' },
            },
          ],
        };
      }

      axios
        .get(endpoint, {
          params: params,
          headers: { 'SOC-PLATFORM': 'review-web-desktop' },
        })
        .then((response) => {
          if (response.status === 200) {
            this.brands = response.data.data;
          } else {
            this.brands = [];
          }
          this.isLoadingFinishSearchFilterBrand = true;
        })
        .catch((err) => {
          console.log(err);
          this.isLoadingFinishSearchFilterBrand = true;
          this.brands = [];
        });
    },
    getProducts() {
      this.products.loading = true;
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/products`, {
          params: {
            // section: "getProducts",
            filter: Object.assign(this.getCriteriaFilter(), { is_exclude_combinations_stores: true }),
            limit: this.limitForProduct,
            sort: this.paramsOfSort,
            skip: this.skipForProduct,
            fields:
              'id name brand images review_stats total_reviews default_category price parent_category is_wishlist',
          },
        })
        .then((res) => {
          if (res.status === 200) {
            this.products.data = res.data.data;
            this.products.loading = false;
            this.$store.commit('setListProducts', res.data.data);
            // console.log(this.products.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProductsTotal() {
      this.products.loading = true;
      this.countproducts = true;
      const filter = this.getCriteriaFilter();
      delete filter.is_reviewed;
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/products/count`, {
          params: {
            section: 'getProductsTotal',
            filter: filter,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            this.products.total = res.data.data;
            if (res.data.data > 0) {
              this.getProducts();
            } else {
              this.products.loading = false;
              this.$store.commit('setListProducts', []);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCriteriaFilter() {
      const filter = {};

      if (this.queryStringOfCategoryId) {
        filter['categories.id'] = this.queryStringOfCategoryId;
        filter['is_reviewed'] = true;
      }

      if (this.brandId && this.countproducts === true) {
        filter['brand.country_tag_id'] = +this.brandId;
        filter['is_deleted'] = false;
      } else {
        filter['brand.country_tag_id'] = +this.brandId;
        filter['is_deleted'] = false;
        filter['is_reviewed'] = true;
      }

      if (this.$route.query.brand_id) {
        filter['brand.id'] = { $in: JSON.parse(this.$route.query.brand_id) };
      }

      if (this.queryStringOfRatingValue) {
        const queryStringOfRatingValueConvertToInt = parseInt(this.queryStringOfRatingValue);
        filter['$and'] = [
          {
            'review_stats.average_rating': {
              $gte: queryStringOfRatingValueConvertToInt,
            },
          },
          {
            'review_stats.average_rating': {
              $lte: queryStringOfRatingValueConvertToInt + 0.999,
            },
          },
        ];
      }

      if (this.$route.query.available_for) {
        if (this.$route.query.available_for.includes('sociolla') && this.$route.query.available_for.includes('lulla')) {
          // console.log("2 filter")
          filter['is_active_in_sociolla'] = true;
          filter['is_active_in_lulla'] = true;
        } else if (this.$route.query.available_for.includes('lulla')) {
          // console.log("1 filter lulla")
          filter['is_active_in_lulla'] = true;
        } else {
          // console.log("1 filter sociolla")
          filter['is_active_in_sociolla'] = true;
        }
      }
      return filter;
    },
    onChangeCategory(newValue) {
      this.valueForQueryString.category_id = newValue;
      this.valueForQueryString.filter_rating = '';
      // this.filterRatingChecked = '';
      this.applyRouteChange();
    },
    onChangeFilterRating(newRating) {
      this.filterRatingChecked = '';
      this.valueForQueryString.filter_rating = newRating !== 'all ratings' ? newRating : '';
      if (!this.createdHookInit) {
        this.resetPaginationState();
      }
      this.createdHookInit = false;
      this.applyRouteChange();
    },
    onChangePagination(pagination) {
      const newSkip = this.limitForProduct * (pagination.number - 1);
      this.skipForProduct = newSkip;
      this.valueForQueryString.page = pagination.number;
      this.applyRouteChange();
    },
    onChangeSortDate(newText) {
      const isTriggerNewSorting = newText !== this.dropdownToggleText;
      if (isTriggerNewSorting) {
        this.dropdownToggleText = newText;
        this.sortProduct = this.$options.filters.generateSortingProduct(newText);
        if (this.dropdownToggleText) {
          this.toggleTextSortDate = newText;
          this.valueForQueryString.sort = newText;
          this.applyRouteChange();
          this.applyParamsOfSortValue();
        }
      }
    },
    resetPaginationState() {
      this.valueForQueryString.page = 1;
      this.skipForProduct = 0;
    },
    setDefaultFilter() {
      if (this.queryStringOfSortDateValue) {
        this.toggleTextSortDate = this.$options.filters.ucwords(this.queryStringOfSortDateValue);
        this.valueForQueryString.sort = this.queryStringOfSortDateValue;
      }

      if (this.queryStringOfRatingValue) {
        this.filterRatingChecked = this.queryStringOfRatingValue;
        this.filterRating = this.queryStringOfRatingValue;
        this.valueForQueryString.rating = this.queryStringOfRatingValue;
      }

      if (this.queryStringOfCategoryId) {
        this.valueForQueryString.category_id = this.queryStringOfCategoryId;
      }
    },
    setParams() {
      if (this.queryStringOfSortDateValue) {
        this.applyParamsOfSortValue();
      }

      if (this.queryStringOfPageValue > 1) {
        this.skipForProduct = this.queryStringOfPageValue;
      }

      if (this.queryStringOfPageValue) {
        this.valueForQueryString.page = this.queryStringOfPageValue;
      }
    },
    brandImageErrorHandler(e) {
      e.target.src = '/assets/img/default_img_brand.svg';
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=74',
        image: src,
      });
    },
    setSelectedCategory(id = '', level) {
      if (level === 1) {
        this.selectedCategories.parent = id;
      }
      if (level === 2) {
        this.selectedCategories.child = id;
      }
      if (level === 3) {
        this.selectedCategories.grandchild = id;
      }
      this.onChangeCategory(id);
    },
    resetFilter() {
      this.filterRating = '';
      this.filterAvailChecked = [];
      this.filterBrandChecked = [];
      this.$router.push(`/brand/${this.brandId}-${this.$options.filters.slug(this.brand.data.country)}`);
      this.resetPaginationState();
      this.getProducts();
      this.getProductsTotal();
    },
  },
};
</script>

<style lang="scss" scoped>
.row__product {
  display: flex;
  flex-wrap: wrap;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-flow: row wrap;
}

.column-mobile {
  flex: 0 0 auto;
  margin-bottom: 16px;
}

.see-more {
  color: #b32656;
  font: 11px/15px 'lato-bold', sans-serif;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding-right: 15px;
  display: table;
}

.basic-icon--uniform {
  &.see-more-with-icon {
    &:after {
      margin-top: -13px;
    }
  }

  &.see-more-with-icon.see-less {
    &:after {
      @include transform(rotate(180deg));
    }
  }
}
</style>
